import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useGetExchange } from "@/api/entities/exchange/hooks/use-get-exchange";

import { TEXT } from "@/shared/constants/text";
import { getExchangeRoute } from "@/shared/constants/routers";
import { useActiveExchange } from "@/shared/hooks/useActiveExchange";
import { clearActiveExchange } from "@/shared/lib/active-exchange";
import { isFinalStatus } from "@/shared/lib/exchange-status";

/** Через сутки заявка считается брошенной и плашка гаснет. */
const STALE_AFTER_MS = 24 * 60 * 60 * 1000;

/**
 * Возврат к незавершённой заявке из любого раздела. Заявку опрашиваем тем же
 * хуком, что и её экран: react-query склеит запросы по общему ключу.
 */
export const ActiveExchangeBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const active = useActiveExchange();

  const isOnExchangePage = location.pathname.startsWith("/exchange/");

  const { data: exchange } = useGetExchange(active?.id ?? null, true);

  useEffect(() => {
    if (!exchange) {
      return;
    }

    // брошенные заявки могут висеть в IN_PROGRESS бесконечно (в базе таких
    // десятки), а плашка «активный обмен» на них горела бы вечно
    const isStale =
      Date.now() - new Date(exchange.createdAt).getTime() > STALE_AFTER_MS;

    if (isFinalStatus(exchange.statusExchange) || isStale) {
      clearActiveExchange();
    }
  }, [exchange]);

  if (!active || isOnExchangePage) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(getExchangeRoute(active.id))}
      className="mx-4 mb-3 flex w-[calc(100%-2rem)] items-center gap-2 rounded-[11px] border border-[rgba(203,241,70,.3)] bg-[rgba(203,241,70,.16)] px-[11px] py-2 text-left"
    >
      <span className="size-[7px] shrink-0 animate-pulse rounded-full bg-(--green-main) motion-reduce:animate-none" />

      <span className="flex-1 text-[12px] text-(--white)">
        {TEXT.exchangeStatus.banner}
      </span>

      <span aria-hidden className="font-bold text-(--green-main)">
        →
      </span>
    </button>
  );
};
